import { Physics } from 'phaser';
import App from '../main';

export default class BaseGamePlay extends Phaser.Scene {
    protected key: string;

    protected player: any;
    protected playerScale: number = 0.75 * 0.4;
    protected platforms: Phaser.Physics.Arcade.Group;
    protected nextPlatform: number = 0;
    protected platformAmount: number = 9;
    protected platformStep: number = 0.75 * 350;
    protected numberOfPlatforms: number = 0;
    protected obstacles: Phaser.Physics.Arcade.Group;
    protected collectibles: Phaser.Physics.Arcade.Group;
    protected rubixCubes: number = 0;
    protected rubixCubeScore: number = 0;
    protected score: number = 0;
    protected gameScore: number = 0;
    protected highScore: number = 0;
    protected starScore: number = 1;
    protected rainbowStarScore: number = 5;
    protected gameOver: boolean = false;
    protected offset: number;

    protected starParticles: Phaser.GameObjects.Particles.ParticleEmitterManager;
    protected clouds: Phaser.GameObjects.Sprite[];

    protected inputEnabled: boolean = true;

    protected currentCollectibles: string;
    protected currentStar: string;
    protected currentPowerUp: string;
    protected activePowerUp: string = '';
    protected isRushMode: boolean = false;
    protected special1: number = -1;
    protected special2: number = -1;
    protected obstacle: number = -1;
    protected rubix1: number = -1;
    protected rubix2: number = -1;
    protected power: number = -1;

    protected currentY: number;

    protected gradient: Phaser.GameObjects.Sprite;
    protected bgRand: number = Phaser.Math.Between(0, 10);
    protected colorChangeTween: Phaser.Tweens.Tween;

    protected platformRand: number = Phaser.Math.Between(0, 8);
    protected patternRand: number = Phaser.Math.Between(0, 9);

    protected bg1 = new Phaser.Display.Color(206, 223, 255);
    protected bg2 = new Phaser.Display.Color(140, 233, 244);
    protected bg3 = new Phaser.Display.Color(201, 237, 255);
    protected bg4 = new Phaser.Display.Color(247, 213, 204);
    protected bg5 = new Phaser.Display.Color(207, 255, 241);
    protected bg6 = new Phaser.Display.Color(168, 246, 246);
    protected bg7 = new Phaser.Display.Color(255, 182, 165);
    protected bg8 = new Phaser.Display.Color(255, 184, 217);
    protected bg9 = new Phaser.Display.Color(147, 161, 178);
    protected bg10 = new Phaser.Display.Color(253, 153, 181);
    protected bg11 = new Phaser.Display.Color(193, 243, 255);
    protected backgroundColors = [this.bg1, this.bg2, this.bg3, this.bg4, this.bg5, this.bg6, this.bg7, this.bg8, this.bg9, this.bg10, this.bg11];

    protected gr1 = new Phaser.Display.Color(255, 161, 214);
    protected gr2 = new Phaser.Display.Color(255, 168, 124);
    protected gr3 = new Phaser.Display.Color(255, 152, 165);
    protected gr4 = new Phaser.Display.Color(253, 140, 154);
    protected gr5 = new Phaser.Display.Color(90, 225, 236);
    protected gr6 = new Phaser.Display.Color(108, 172, 245);
    protected gr7 = new Phaser.Display.Color(251, 133, 145);
    protected gr8 = new Phaser.Display.Color(185, 144, 231);
    protected gr9 = new Phaser.Display.Color(70, 81, 92);
    protected gr10 = new Phaser.Display.Color(206, 79, 141);
    protected gr11 = new Phaser.Display.Color(139, 155, 255);
    protected gradientColors = [this.gr1, this.gr2, this.gr3, this.gr4, this.gr5, this.gr6, this.gr7, this.gr8, this.gr9, this.gr10, this.gr11];

    protected topColors: number[] = [0xFED938, 0xFF7687, 0x64F2CC, 0xFF816B, 0xFF85C9, 0xBEAEFF, 0x8DC0FF, 0x85909E];
    protected fillColors: number[] = [0xFAC12F, 0xFF5869, 0x1FDBAA, 0xF9674D, 0xF859B2, 0xA591E4, 0x5D99E3, 0x525A63];
    protected spikeFillColor: number = 0xE7E7E7;
    protected patternKeys: string[] = ['Platforms_2', 'Platforms_1', 'Platforms_1', 'Platforms_1', 'Platforms_2', 'Platforms_2', 'Platforms_2', 'Platforms_2', 'Platforms_3'];
    protected patternFrames: string[] = ['Platforms_2_0', 'Platforms_1_3', 'Platforms_1_4', 'Platforms_1_2', 'Platforms_2_1', 'Platforms_2_2', 'Platforms_2_3', 'Platforms_2_4', 'Platforms_3_0'];
    protected patternAlpha: number = 0.4352941;

    protected emitter: Phaser.Events.EventEmitter = new Phaser.Events.EventEmitter();

    protected width: number;
    protected height: number;
    protected width_half: number;
    protected height_half: number;

    constructor(key, gravity) {
        super({
            key: key,
            physics: {
                arcade: {
                    gravity: { y: gravity },
                    debug: false
                }
            },
        });
        this.key = key;
    }

    create() {
        this.inputEnabled = true;
        // if (localStorage.getItem('hammerplay_doodledrop_highscore') == null) {
        //     localStorage.setItem('hammerplay_doodledrop_highscore', '0')
        // } else {
        //     App.SDK.HighestScore = +localStorage.getItem('hammerplay_doodledrop_highscore');
        // }
        this.highScore = App.SDK.HighestScore;
        var reference = this.add.image(App.MAX_WIDTH_HALF, App.MAX_HEIGHT_HALF, 'bob')
        reference.visible = false;
        this.cameras.main.startFollow(reference);
        this.cameras.main.stopFollow();
        this.scale.on('resize', (gameSize: any) => {
            this.resize(gameSize);
        })
        this.resize(this.scale.gameSize);
        this.width = this.cameras.main.displayWidth;
        this.height = this.cameras.main.displayHeight;
        this.width_half = this.width / 2;
        this.height_half = this.height / 2;

        App.AD_SHOWN = false;

        this.physics.world.setBoundsCollision(false, false, false, false);

        this.setBackground();

        this.setData();
        this.registry.set('powerup', this.activePowerUp);

        this.starParticles = this.add.particles(0, 0, 'PowerUps', {
            frame: 'PowerUps_2',
            angle: { min: 0, max: 360, steps: 9 },
            lifespan: 500,
            speed: 400,
            quantity: 40,
            scale: { start: 0.75 * 0.5, end: 0 },
            emitting: false
        });
        // this.starParticles = this.add.particles('PowerUps', 'PowerUps_2');
        // this.starParticles.createEmitter({
        //     angle: { min: 0, max: 360, steps: 9 },
        //     lifespan: 500,
        //     speed: 400,
        //     quantity: 40,
        //     scale: { start: 0.75 * 0.5, end: 0 },
        //     on: false
        // });

        this.setAnims();

        this.collectibles = this.physics.add.group();
        this.obstacles = this.physics.add.group();

        this.initPlatforms();

        this.player = this.physics.add.sprite(App.MAX_WIDTH_HALF, 75, App.characters[App.characterIndex][0], App.characters[App.characterIndex][1]).setScale(this.playerScale).setOrigin(0.5, 1);
        this.player.setBounce(0).setCollideWorldBounds(false);
        this.player.stayOnPlatform = true;
        this.sound.play('Drop');

        this.physics.add.collider(this.player, this.platforms, this.playerOnPlatform, null, this);

        this.physics.add.overlap(this.player, this.collectibles, this.collectCollectible, null, this);

        this.input.on('pointerdown', this.pointerDownHandler, this);

        if (this.cameras.main.listenerCount('camerafadeoutstart') <= 0) {
            this.cameras.main.on('camerafadeoutstart', () => this.inputEnabled = false, this);
        }
        if (this.cameras.main.listenerCount('camerafadeoutcomplete') <= 0) {
            this.cameras.main.on('camerafadeoutcomplete',  () => {
                if (this.isRushMode) {
                    this.scene.switch('NormalMode');
                }
                else {
                    this.scene.switch('RushMode');
                }
            }, this);
        }

        if (this.events.listenerCount('resume') <= 0) {
            this.events.on('resume', () => this.cameras.main.setAlpha(1), this);
        }
        if (this.emitter.listenerCount('rush') <= 0) {
            this.emitter.on('rush', this.switchToRushMode, this);
        }
        if (this.emitter.listenerCount('gameover') <= 0) {
            this.emitter.once('gameOver', this.setGameOver, this);
        }
        if (this.emitter.listenerCount('fall') <= 0) {
            this.emitter.once('fall', this.fall, this);
        }
        if (this.cameras.main.listenerCount('camerashakecomplete') <= 0) {
            this.cameras.main.once('camerashakecomplete', this.showGameOverMenu, this);
        }
        this.events.once('shutdown', () => {
            if (this.colorChangeTween) this.colorChangeTween.stop();
        });
    }

    setAnims() {
    if (!this.anims.exists('rubix')) {
        this.anims.create({
            key: 'rubix',
            frames: this.anims.generateFrameNames('RubixCube'),
            frameRate: 24,
            repeat: -1
        });
    }
}

    setBackground() {
        this.cameras.main.setBackgroundColor(this.backgroundColors[this.bgRand].color);
        this.gradient = this.add.sprite(App.MAX_WIDTH_HALF, App.MAX_HEIGHT, 'BG_Gradients').setScale(0.75 * 3, 0.75 * 1.5);
        this.gradient.setTint(this.gradientColors[this.bgRand].color).setAlpha(0.7333333).setScrollFactor(1, 0);
        this.setClouds();
    }

    setClouds() {
        this.clouds = [
            this.add.sprite(App.MAX_WIDTH_HALF * 0.55, 0.75 * 600, 'Clouds_2', 'Clouds_2_0').setScale(0.75 * 0.8).setAlpha(0.2392157),
            this.add.sprite(App.MAX_WIDTH - App.MAX_WIDTH_HALF * 0.55, 0.75 * 1000, 'Clouds_2', 'Clouds_2_1').setScale(0.75 * 0.8).setAlpha(0.2392157),
            this.add.sprite(App.MAX_WIDTH_HALF * 0.55, 0.75 * 1400, 'Clouds_2', 'Clouds_2_2').setScale(0.75 * 0.8).setAlpha(0.2392157),
            this.add.sprite(App.MAX_WIDTH - App.MAX_WIDTH_HALF * 0.55, 0.75 * 1800, 'Clouds_2', 'Clouds_2_3').setScale(0.75 * 0.8).setAlpha(0.2392157),
            this.add.sprite(App.MAX_WIDTH_HALF * 0.55, 0.75 * 2200, 'Clouds_2', 'Clouds_2_0').setScale(0.75 * 0.8).setAlpha(0.2392157),
            this.add.sprite(App.MAX_WIDTH - App.MAX_WIDTH_HALF * 0.55, 0.75 * 2600, 'Clouds_2', 'Clouds_2_1').setScale(0.75 * 0.8).setAlpha(0.2392157),
            this.add.sprite(App.MAX_WIDTH_HALF * 0.55, 0.75 * 3000, 'Clouds_2', 'Clouds_2_2').setScale(0.75 * 0.8).setAlpha(0.2392157),
            this.add.sprite(App.MAX_WIDTH - App.MAX_WIDTH_HALF * 0.55, 0.75 * 3400, 'Clouds_2', 'Clouds_2_3').setScale(0.75 * 0.8).setAlpha(0.2392157),
            this.add.sprite(App.MAX_WIDTH_HALF * 0.55, 0.75 * 3800, 'Clouds_2', 'Clouds_2_0').setScale(0.75 * 0.8).setAlpha(0.2392157),
            this.add.sprite(App.MAX_WIDTH - App.MAX_WIDTH_HALF * 0.55, 0.75 * 4200, 'Clouds_2', 'Clouds_2_1').setScale(0.75 * 0.8).setAlpha(0.2392157),
            this.add.sprite(App.MAX_WIDTH_HALF * 0.55, 0.75 * 4600, 'Clouds_2', 'Clouds_2_2').setScale(0.75 * 0.8).setAlpha(0.2392157),
            this.add.sprite(App.MAX_WIDTH - App.MAX_WIDTH_HALF * 0.55, 0.75 * 5000, 'Clouds_2', 'Clouds_2_3').setScale(0.75 * 0.8).setAlpha(0.2392157),
            this.add.sprite(App.MAX_WIDTH_HALF * 0.55, 0.75 * 5400, 'Clouds_2', 'Clouds_2_0').setScale(0.75 * 0.8).setAlpha(0.2392157),
            this.add.sprite(App.MAX_WIDTH - App.MAX_WIDTH_HALF * 0.55, 0.75 * 5800, 'Clouds_2', 'Clouds_2_1').setScale(0.75 * 0.8).setAlpha(0.2392157),
            this.add.sprite(App.MAX_WIDTH_HALF * 0.55, 0.75 * 6200, 'Clouds_2', 'Clouds_2_2').setScale(0.75 * 0.8).setAlpha(0.2392157),
            this.add.sprite(App.MAX_WIDTH - App.MAX_WIDTH_HALF * 0.55, 0.75 * 6600, 'Clouds_2', 'Clouds_2_3').setScale(0.75 * 0.8).setAlpha(0.2392157),
            this.add.sprite(App.MAX_WIDTH_HALF * 0.55, 0.75 * 7000, 'Clouds_2', 'Clouds_2_0').setScale(0.75 * 0.8).setAlpha(0.2392157),
            this.add.sprite(App.MAX_WIDTH - App.MAX_WIDTH_HALF * 0.55, 0.75 * 7400, 'Clouds_2', 'Clouds_2_1').setScale(0.75 * 0.8).setAlpha(0.2392157),
            this.add.sprite(App.MAX_WIDTH_HALF * 0.55, 0.75 * 7800, 'Clouds_2', 'Clouds_2_2').setScale(0.75 * 0.8).setAlpha(0.2392157),
            this.add.sprite(App.MAX_WIDTH - App.MAX_WIDTH_HALF * 0.55, 0.75 * 8200, 'Clouds_2', 'Clouds_2_3').setScale(0.75 * 0.8).setAlpha(0.2392157)
        ];
    }

    update() {
        if (!this.player.body.touching.down) {
            this.player.setVelocityX(0);
        }
        this.platforms.children.iterate( (platform: any) => {
            if (platform.collectible.glow && platform.collectible.glow.visible) {
                platform.collectible.glow.angle += 1;
            }
        });
    }

    setData() {
        this.registry.set('score', this.score);
        this.registry.set('highScore', this.highScore);
        this.registry.set('rubixCubeScore', this.rubixCubeScore);
        this.getStars();
    }

    addScore(scoreToAdd, isStar) {
        this.score += scoreToAdd;
        this.registry.set('score', this.score);
        if (this.score > this.highScore) {
            this.highScore = this.score;
            this.registry.set('highScore', this.highScore);
        }
    }

    getStars() {
        // App.stars = +localStorage.getItem('hammerplay_doodledrop_stars');
        this.registry.set('stars', App.stars);
    }

    addStars(starsToAdd) {
        App.stars += starsToAdd;
        this.registry.set('stars', App.stars);
        App.SDK.setDataStars(App.stars);
        // localStorage.setItem('hammerplay_doodledrop_stars', App.stars.toString());
        
    }

    playerOnPlatform(player, platform) {
        if (player.body.touching.down && platform.body.touching.up) {
            if (this.gameOver) {
                this.emitter.emit('fall');
                if (platform.spikeDesign.visible) {
                    player.setTexture('Character_Dead' + App.characterIndex);
                }
            }
            if (player.x > platform.x + (platform.displayWidth / 2)) {
                if (!this.gameOver) {
                    this.emitter.emit('fall');
                    player.stayOnPlatform = false;
                    player.body.setAcceleration(30000, 0).setAngularVelocity(240);
                }
            }
            else if (player.x < platform.x - (platform.displayWidth / 2)) {
                if (!this.gameOver) {
                    this.emitter.emit('fall');
                    player.stayOnPlatform = false;
                    player.body.setAcceleration(0.75 * -30000, 0).setAngularVelocity(0.75 * -240);
                }
            }
            else {
                if (!platform.isCurrentPlatform) {
                    if (!this.gameOver) {
                        if (!platform.isFirstPlatform) {
                            if(!App.revieved){
                                this.addScore(1, false);
                            }
                            this.moveCamera(platform);
                        }
                        if (this.nextPlatform < this.platforms.getLength() - 1) {
                            this.nextPlatform++;
                        }
                        else {
                            this.nextPlatform = 0;
                        }
                        if (!this.isRushMode) {
                            player.squashTween = this.tweens.add({
                                targets: player,
                                duration: 1000 * 0.125,
                                scaleY: player.scaleY / 2,
                                yoyo: true
                            });
                            platform.mouth.angle = 0;
                            platform.setVisible(true).design.setVisible(true);
                            platform.spikeDesign.setVisible(false);

                            if (this.gameScore >= 10 && (this.gameScore % 10 == 0 || this.gameScore == 65)) {
                                this.changeBackground();
                            }
                            var nextPlatform: any = this.platforms.getChildren()[this.nextPlatform];
                            nextPlatform.setVisible(true).design.setVisible(true);
                            nextPlatform.spikeDesign.setVisible(false);
                            nextPlatform.collectible.setVisible(true);
                            if (nextPlatform.collectible.type != 'star') {
                                nextPlatform.collectible.glow.setVisible(true);
                            }
                        }
                        platform.isCurrentPlatform = true;
                    }
                    this.offset = player.x - platform.x;
                }
                if (player.stayOnPlatform) {
                    player.x = platform.x + this.offset;
                }
            }

        }
    }

    moveCamera(platform) {
        var cameraPos = this.cameras.main.scrollY;
        var duration = 0.75 * 400;
        var distance = platform.y - this.currentY;
        if (this.isRushMode) {
            duration = 0.75 * 150;
            distance = 0.75 * 200;
        }
        this.tweens.add({
            targets: this.cameras.main,
            scrollY: cameraPos + distance,
            duration: duration
        });
        this.clouds.forEach( (cloud) => {
            if (this.cameras.main.scrollY > cloud.y && !this.cameras.main.worldView.contains(cloud.x, cloud.y)) {
                cloud.y += 0.75 * 8000;
            }
        }, this);
    }

    changeBackground() {
       this.bgRand = Phaser.Math.Between(0, 10);
        var currentBGColor = this.cameras.main.backgroundColor;
        var newBGColor = this.backgroundColors[this.bgRand];

        var currentGradient = Phaser.Display.Color.IntegerToColor(this.gradient.tintTopLeft);
        var newGradient = this.gradientColors[this.bgRand];
        this.colorChangeTween = this.tweens.addCounter({
            from: 0,
            to: 100,
            duration: 2000,
            onUpdate:  (tween) => {
                if (!this.scene.isActive() || !this.cameras.main || !this.gradient.scene) return;
                var bgColor = Phaser.Display.Color.Interpolate.ColorWithColor(currentBGColor, newBGColor, 100, tween.getValue());
                this.cameras.main.setBackgroundColor(bgColor);

                var gradientColorObj = Phaser.Display.Color.Interpolate.ColorWithColor(currentGradient, newGradient, 100, tween.getValue());
                var gradientColor = Phaser.Display.Color.ObjectToColor(gradientColorObj).color;
                this.gradient.setTint(gradientColor);
            },
            onUpdateScope: this
        });
    }

    switchToRushMode() {
        if (!this.gameOver) {
            this.sound.play('Star');
            this.registry.set('score', this.score);
            this.registry.set('highScore', this.highScore);
            this.cameras.main.fadeOut(250, 255, 255, 255);
            this.rubixCubeScore = 0;
            this.registry.set('rubixCubeScore', this.rubixCubeScore);
            var fadeDuration = 250;
            this.cameras.main.fadeOut(fadeDuration, 255, 255, 255);
        }
    }

    setGameOver() {
        App.vibrate(100);
        this.gameOver = true;
        return;
    }

    fall() {
        this.sound.play('Fall', { volume: 0.8 });
        this.cameras.main.shake(300, 0.01);
    }

    showGameOverMenu() {
        this.emitter.emit('gameOverScreen');
    }

   restartGame() {
    if (this.colorChangeTween && this.colorChangeTween.isPlaying()) {
        this.colorChangeTween.stop();
    }
    this.gameOver = false;
    this.score = 0;
    this.gameScore = 0;
    this.rubixCubes = 0;
    this.rubixCubeScore = 0;
    this.rubix1 = -1;
    this.rubix2 = -1;
    this.power = -1;
    this.special1 = -1;
    this.special2 = -1;
    this.obstacle = -1;

    this.nextPlatform = 0;
    this.platformStep = 0.75 * 350;
    this.registry.set('score', this.score);
    this.registry.set('highScore', this.highScore);
    this.registry.set('rubixCubeScore', this.rubixCubeScore);
    this.activePowerUp = '';
    this.registry.set('powerup', this.activePowerUp);
    this.setPlatformDesignRandoms();
    this.bgRand = Phaser.Math.Between(0, 10);
    this.player.stayOnPlatform = true;

    this.scene.restart();
}

    revive() {
         this.platforms.children.iterate((platform: any) => {
        if (platform.startTween && platform.startTween.isPlaying()) {
            platform.startTween.pause();
        }
        else if (platform.tween && platform.tween.isPlaying()) {
            platform.tween.pause();
        }
    });
        var highest = this.getHighestPlatform();
        this.player.setTexture(App.characters[App.characterIndex][0], App.characters[App.characterIndex][1]).setScale(this.playerScale);
        this.player.body.setAcceleration(0, 0).setAngularVelocity(0);
        this.player.angle = 0;
        this.player.disableBody(true, true);
        this.player.enableBody(true, highest.x, highest.y - highest.height, true, true);
        this.offset = 0;
        this.player.stayOnPlatform = true;
        this.gameOver = false;
        if (this.emitter.listenerCount('gameover') <= 0) {
            this.emitter.once('gameOver', this.setGameOver, this);
        }
        if (this.emitter.listenerCount('fall') <= 0) {
            this.emitter.once('fall', this.fall, this);
        }
        if (this.cameras.main.listenerCount('camerashakecomplete') <= 0) {
            this.cameras.main.once('camerashakecomplete', this.showGameOverMenu, this);
        }
        App.revieved = true;
        this.time.delayedCall(500, () => {
            this.platforms.children.iterate((platform: any) => {
               if (platform.startTween && platform.startTween.isPaused()) {
                    platform.startTween.resume();
                }
                else if (platform.tween.hasStarted && platform.tween.isPaused()) {
                    platform.tween.resume();
                App.revieved = false;
                }
            }, this);
        }, [], this);
    }

    setCollectibleProbability(init) {
        var indexes = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];
        var p = parseInt(this.numberOfPlatforms.toString()[0]);
        if (this.numberOfPlatforms <= 10) {
            Phaser.Utils.Array.Remove(indexes, 0);
        }
        if (p == 6) {
            this.rubix1 = -1;
            this.rubix2 = -1;
            this.power = -1;
        }
        if (p % 2 == 0 || init) {
            this.rubix1 = Phaser.Math.RND.pick(indexes);
            Phaser.Utils.Array.Remove(indexes, this.rubix1);
        }
        else if (p % 2 == 1) {
            this.rubix1 = Phaser.Math.RND.pick(indexes);
            Phaser.Utils.Array.Remove(indexes, this.rubix1);
            this.rubix2 = Phaser.Math.RND.pick(indexes);
            Phaser.Utils.Array.Remove(indexes, this.rubix2);
        }
        if (this.numberOfPlatforms > 10) {
            this.power = Phaser.Math.RND.pick(indexes);
        }
    }

    spawnCollectibles(platform) {
        this.randomizeCollectibles(platform);
        this.setCollectibles(platform);
    }

    randomizeCollectibles(platform) {
        if (platform == this.platforms.getChildren()[this.rubix1]) {
            this.currentCollectibles = 'rubixCube';
        }
        else if (platform == this.platforms.getChildren()[this.rubix2]) {
            this.currentCollectibles = 'rubixCube';
        }
        else if (platform == this.platforms.getChildren()[this.power]) {
            this.currentCollectibles = 'powerup';
            this.randomizePowerUp();
        }
        else {
            this.currentCollectibles = 'star';
            this.randomizeStar();
        }
    }

    randomizeStar() {
        var rand = Phaser.Math.FloatBetween(0, 1);
        if (rand <= 0.8) {
            this.currentStar = 'star';
        }
        else {
            if (this.score > 10)
                this.currentStar = 'rainbow';
            else
                this.currentStar = 'star';
        }
    }

    randomizePowerUp() {
        this.currentPowerUp = Phaser.Math.RND.pick(['spring', 'ice', 'cheese']);
    }

    setCollectibles(platform) {
        switch (this.currentCollectibles) {
            case 'star':
                if (this.currentStar == 'star') {
                    platform.collectible.setTexture('PowerUps', 'PowerUps_2').setScale(0.75 * 0.4);
                    platform.collectible.star = 'star';
                }
                else {
                    platform.collectible.setTexture('PowerUps', 'PowerUps_3').setScale(0.75 * 0.4);
                    platform.collectible.star = 'rainbow';
                }
                platform.collectible.type = 'star';
                break;
            case 'rubixCube':
                platform.collectible.setTexture('RubixCube', 'RubixCube_0').setScale(0.75 * 1);
                platform.collectible.type = 'rubixcube';
                platform.collectible.play('rubix');
                this.rubixCubes++;
                break;
            case 'powerup':
                if (this.currentPowerUp == 'spring') {
                    platform.collectible.setTexture('PowerUps', 'PowerUps_1').setScale(0.75 * 0.4);
                    platform.collectible.type = 'spring';
                }
                else if (this.currentPowerUp == 'cheese') {
                    platform.collectible.setTexture('PowerUps', 'PowerUps_5').setScale(0.75 * 0.4);
                    platform.collectible.type = 'cheese';
                }
                else if (this.currentPowerUp == 'ice') {
                    platform.collectible.setTexture('PowerUps', 'PowerUps_10').setScale(0.75 * 0.4);
                    platform.collectible.type = 'ice';
                }
                break;
            default:
                break;
        }
        platform.collectible.body.setSize(platform.collectible.width, platform.collectible.height, false);
    }

    collectCollectible(player, collectible) {
        if (!this.gameOver) {
            collectible.disableBody(true, true);
            if (!this.isRushMode && collectible.type != 'star') {
                collectible.glow.setVisible(false);
            }
            if (!App.revieved) {
                switch (collectible.type) {
                    case 'star':
                        this.collectStar(collectible);
                        break;
                    case 'rubixcube':
                        App.vibrate(50);
                        this.collectRubixCube(player, collectible);
                        break;
                    case 'spring':
                        App.vibrate(50);
                        this.collectSpring();
                        break;
                    case 'cheese':
                        App.vibrate(50);
                        this.collectCheese(collectible);
                        break;
                    case 'ice':
                        App.vibrate(50);
                        this.collectIce(collectible);
                        break;
                    default:
                        break;
                }
            }
        }
    }

    // Star
    collectStar(star) {
        this.sound.play('Star');
        if (star.star == 'star') {
            this.addScore(this.starScore, true);
            this.addStars(this.starScore);
        }
        else if (star.star == 'rainbow') {
            this.addScore(this.rainbowStarScore, true)
            this.addStars(this.rainbowStarScore);
        }
        this.starParticles.emitParticleAt(star.x, star.y);
    }

    // Rush Mode
    collectRubixCube(player, rubixCube) {
        rubixCube.anims.stop();
        rubixCube.anims.remove('rubix');
        this.sound.play('Power Up');
        this.rubixCubeScore++;
        this.registry.set('rubixCubeScore', this.rubixCubeScore);
        if (this.rubixCubeScore == 3) {
            this.emitter.emit('rush');
        }
    }

    // Enlarge Platforms
    collectSpring() {
        this.sound.play('Power Up');
        this.activePowerUp = 'spring';
        this.registry.set('powerup', this.activePowerUp);
        this.platforms.children.iterate((platform: any) => {
            platform.setScale(platform.scaleX * 1.25, platform.scaleY);
            platform.fill.setScale(platform.scaleX, platform.scaleY);
            platform.top.setScale(platform.scaleX, platform.scaleY);
            platform.pattern.setScale(platform.scaleX, platform.scaleY);
            platform.spikeOutline.setScale(platform.scaleX, platform.scaleY);
            platform.spikeFill.setScale(platform.scaleX, platform.scaleY);
            platform.spikeTop.setScale(platform.scaleX, platform.scaleY);
            platform.spikePattern.setScale(platform.scaleX, platform.scaleY);
            this.updatePlatformTween(platform);
            this.time.delayedCall(App.POWERUP_TIME, () => {
                if (!platform.isCurrentPlatform) {
                    platform.setScale(platform.scaleX / 1.25, platform.scaleY);
                    platform.fill.setScale(platform.scaleX, platform.scaleY);
                    platform.top.setScale(platform.scaleX, platform.scaleY);
                    platform.pattern.setScale(platform.scaleX, platform.scaleY);
                    platform.spikeOutline.setScale(platform.scaleX, platform.scaleY);
                    platform.spikeFill.setScale(platform.scaleX, platform.scaleY);
                    platform.spikeTop.setScale(platform.scaleX, platform.scaleY);
                    platform.spikePattern.setScale(platform.scaleX, platform.scaleY);
                }
                this.updatePlatformTween(platform);
                this.activePowerUp = '';
                this.registry.set('powerup', this.activePowerUp);
            }, [], this);
        }, this);
    }

    // Slow Down Platforms
    collectCheese(cheese) {
        this.sound.play('Power Up');
        this.activePowerUp = 'cheese';
        this.registry.set('powerup', this.activePowerUp);
        this.platforms.children.iterate((platform: any) => {
            if (cheese.platform != platform) {
                if ( platform.startTween && platform.startTween.isPlaying()) {
                    platform.tween.setTimeScale(0.5);
                }
                if (platform.tween && platform.tween.isPlaying()) {
                    platform.tween.setTimeScale(0.5);
                }
                this.time.delayedCall(App.POWERUP_TIME, () => {
                    if (platform.startTween && platform.startTween.isPlaying()) {
                        platform.startTween.setTimeScale(1);
                    }
                    if (platform.tween && platform.tween.isPlaying()) {
                        platform.tween.setTimeScale(1);
                    }
                    this.activePowerUp = '';
                    this.registry.set('powerup', this.activePowerUp);
                }, [], this);
            }
        }, this);
    }

    // Freeze Current Platform
    collectIce(ice) {
        this.sound.play('Power Up');
        var isStart = false;
        this.activePowerUp = 'ice';
        this.registry.set('powerup', this.activePowerUp);
       if (ice.platform.startTween && ice.platform.startTween.isPlaying()) {
            ice.platform.startTween.pause();
            isStart = true;
        }
        else if ( ice.platform.tween && ice.platform.tween.isPlaying()) {
            ice.platform.tween.pause();
        }
        if (this.activePowerUp == 'ice') {
            this.time.delayedCall(App.POWERUP_TIME, () => {
                if (isStart) {
                    ice.platform.startTween.resume();
                }
                else {
                    ice.platform.tween.resume();
                }
                this.activePowerUp = '';
                this.registry.set('powerup', this.activePowerUp);
            }, [], this);
        }

    }

    getCurrentPlatform() {
        var currentPlatform;
        this.platforms.children.iterate((platform: any) => {
            if (platform.isCurrentPlatform) {
                currentPlatform = platform;
            }
        });
        return currentPlatform;
    }

    pointerDownHandler() {
        if (this.inputEnabled) {
            this.removePlatform();
        }
    }

    removePlatform() {
        var toRemove: any = this.getCurrentPlatform();
        if (toRemove && !this.gameOver) {
            this.sound.play('Drop');
            this.currentY = toRemove.y;
            toRemove.isCurrentPlatform = false;
            toRemove.isFirstPlatform = false;
            toRemove.disableBody(true, true);
            toRemove.enableBody(true, App.MAX_WIDTH_HALF, this.setNewY(), true, true);
            if (toRemove.design) {
                toRemove.design.x = toRemove.x;
                toRemove.design.y = toRemove.y;
            }
            if (toRemove.spikeDesign) {
                toRemove.spikeDesign.x = toRemove.x;
                toRemove.spikeDesign.y = toRemove.y;
            }
            if (toRemove.features) {
                toRemove.features.x = toRemove.x;
                toRemove.features.y = toRemove.y;
                toRemove.mouth.angle = 180;
            }
            if (toRemove.collectible) {
                toRemove.collectible.anims.stop();
                toRemove.collectible.anims.remove('rubix');
                toRemove.collectible.disableBody(true, true);
                this.spawnCollectibles(toRemove);
                var visible = false;
                if (this.isRushMode) {
                    visible = true;
                }
                toRemove.collectible.enableBody(true, toRemove.x, toRemove.y - ((toRemove.displayHeight / 2) + 0.75 * 30), true, visible);
                if (!this.isRushMode) {
                    toRemove.collectible.glow.setVisible(false);
                    toRemove.collectible.glow.x = toRemove.collectible.x;
                    toRemove.collectible.glow.y = toRemove.collectible.y;
                }
            }
            if (toRemove.hasObstacle) {
                toRemove.obstacle.y = toRemove.y + this.platformStep;
                toRemove.obstacle.warning.y = toRemove.obstacle.y;
            }
            if (!this.isRushMode) {
                this.numberOfPlatforms++;
                if (this.numberOfPlatforms == 65) {
                    this.numberOfPlatforms = 30;
                }
                if (this.numberOfPlatforms > 10 && this.numberOfPlatforms % 10 == 0) {
                    this.rubixCubes = 0;
                    this.setCollectibleProbability(false);
                    this.setSpecialPlatformProbability();
                    this.setPlatformDesignRandoms();
                }
                toRemove.top.setTintFill(this.topColors[this.platformRand]);
                toRemove.pattern.setTexture(this.patternKeys[this.patternRand], this.patternFrames[this.patternRand]);
                toRemove.fill.setTintFill(this.fillColors[this.platformRand]);
                toRemove.setVisible(false).design.setVisible(false);
                toRemove.spikeDesign.setVisible(true);
                toRemove.spikePattern.setTexture(this.patternKeys[this.patternRand], this.patternFrames[this.patternRand]);
            }
        }
    }

    setSpecialPlatformProbability() {
        var indexes = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];
        this.obstacle = Phaser.Math.RND.pick(indexes);
        if (this.numberOfPlatforms < 30) {
            this.special1 = Phaser.Math.RND.pick(indexes);
        }
        else if (this.numberOfPlatforms < 60) {
            this.special1 = Phaser.Math.RND.pick(indexes);
            Phaser.Utils.Array.Remove(indexes, this.special1);
            this.special2 = Phaser.Math.RND.pick(indexes);
        }
        else {
            this.special1 = -1;
            this.special2 = -1;
        }
    }

    setPlatformStep() {
        if (!this.isRushMode) {
            if (this.numberOfPlatforms <= 30) {
                this.platformStep = 0.75 * 350;
            }
            else if (this.numberOfPlatforms <= 50) {
                var arr = [350, 700];
                this.platformStep = 0.75 * Phaser.Math.RND.pick(arr);
            }
            else {
                var arr = [350, 700, 1050];
                this.platformStep = 0.75 * Phaser.Math.RND.pick(arr);
            }
        }
    }

    setNewY() {
        this.setPlatformStep();
        var newY = this.getLowestPlatform() + this.platformStep;
        this.platforms.children.iterate((platform: any) => {
            if (platform.y == newY) {
                newY += this.platformStep;
            }
        }, this);
        this.obstacles.children.iterate((obstacle: any) => {
            if (obstacle.y == newY) {
                newY += this.platformStep;
            }
        }, this);
        return newY;
    }

    getLowestPlatform() {
        var lowest = 0;
        this.platforms.children.iterate((platform: any) => {
            if (platform.y > lowest) {
                lowest = platform.y;
            }
        });
        return lowest;
    }

    getHighestPlatform() {
        var y = Infinity;
        var x = App.MAX_WIDTH_HALF;
        var height = 0;
        this.platforms.children.iterate((platform: any) => {
            if (platform.y < y) {
                y = platform.y;
                x = platform.x;
                height = platform.displayHeight / 2;
            }
        });
        return { x: x, y: y, height: height };
    }

    initPlatforms() {
        this.platforms = this.physics.add.group({
            key: 'Platforms_1',
            frame: 'Platforms_1_0',
            repeat: this.platformAmount,
            setXY: { x: App.MAX_WIDTH_HALF, y: 0.75 * 600, stepY: this.platformStep }
        });

        this.numberOfPlatforms = this.platforms.getLength();
        this.setCollectibleProbability(true);

        this.platforms.children.iterate((platform: any) => {
            platform.setImmovable(true).body.allowGravity = false;
            platform.setCollideWorldBounds(false).setDepth(1).body.setFrictionX(1);
            platform.isCurrentPlatform = false;
            platform.isAbovePlayer = false;

            platform.fill = this.add.sprite(0, 0.75 * 20, 'Platforms_1', 'Platforms_1_1').setTintFill(this.fillColors[this.platformRand]);
            platform.top = this.add.sprite(0, 0.75 * -5, 'Platforms_1', 'Platforms_1_1').setTintFill(this.topColors[this.platformRand]);
            platform.pattern = this.add.sprite(0, 0.75 * 12, this.patternKeys[this.patternRand], this.patternFrames[this.patternRand]).setAlpha(this.patternAlpha);
            platform.design = this.add.container(platform.x, platform.y, [platform.top, platform.fill, platform.pattern]);

            platform.spikeOutline = this.add.sprite(0, 0.75 * -15, 'Platforms_3', 'Platforms_3_2');
            platform.spikeFill = this.add.sprite(0, 0.75 * 15, 'Platforms_1', 'Platforms_1_1').setTintFill(this.spikeFillColor);
            platform.spikeTop = this.add.sprite(0, 0.75 * -20, 'Platforms_3', 'Platforms_3_3').setTintFill();
            platform.spikePattern = this.add.sprite(0, 0.75 * 17, this.patternKeys[this.patternRand], this.patternFrames[this.patternRand]).setAlpha(this.patternAlpha);
            platform.spikeDesign = this.add.container(platform.x, platform.y, [platform.spikeTop, platform.spikeFill, platform.spikePattern, platform.spikeOutline]);
            platform.spikeDesign.setVisible(false);

            platform.collectible = this.collectibles.create(0, 0, 'PowerUps', 'PowerUps_2').setScale(0.75 * 0.4).setDepth(1);
            platform.collectible.setImmovable(true).body.allowGravity = false;
            platform.collectible.platform = platform;
            this.spawnCollectibles(platform);

            if (!this.isRushMode) {
                platform.hasObstacle = false;
                platform.collectible.glow = this.add.sprite(platform.collectible.x, platform.collectible.y, 'Glow').setScale(0.75 * 0.4);
                platform.collectible.glow.setVisible(false);
                platform.collectible.setVisible(false);
                platform.mouth = this.add.sprite(0, 0.75 * 20, 'Platform', 'Platform_3').setOrigin(0.5);
                platform.mouth.angle = 180;
                platform.leftEye = this.add.sprite(0, 0, 'Platform', 'Platform_2').setScale(0.75 * 0.3).setOrigin(0.5);
                platform.rightEye = this.add.sprite(0, 0, 'Platform', 'Platform_2').setScale(0.75 * 0.3).setOrigin(0.5);
                platform.features = this.add.container(platform.x, platform.y, [platform.mouth, platform.leftEye, platform.rightEye]).setDepth(6);
            }
        }, this)
    }

    updatePlatformTween(platform) {
        platform.destination1 = platform.displayWidth / 2;
        platform.destination2 = App.MAX_WIDTH - platform.displayWidth / 2;
        if (platform.rand < 0.5) {
            platform.destination1 = App.MAX_WIDTH - platform.displayWidth / 2;
            platform.destination2 = platform.displayWidth / 2;
        }
    }

    setPlatformDesignRandoms() {
        this.platformRand = Phaser.Math.Between(0, 8);
        this.patternRand = Phaser.Math.Between(0, 9);
    }

    private resize(gameSize?: any) {
        this.cameras.main.width = gameSize.width;
        this.cameras.main.height = gameSize.height;
    }
}